const getCheckoutSessionId = (store, router) => {
  const currentRoute = router?.currentRoute

  return (
    currentRoute?.params?.checkoutId ||
    currentRoute?.query?.checkoutId ||
    store.state.session.checkoutId
  )
}

export { getCheckoutSessionId }
